module.exports = __webpack_public_path__ + "img/logo-paypal-branco.d18b84c0.svg";